// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import 'swiper/swiper-bundle.css'
import './style/element-library.scss'
import './style/variables.scss'
import './style/homepage.scss'
import './style/index.scss'
import './style/about.scss'
import en from './lang/en';
import cn from './lang/cn';
import jp from './lang/jp';

Vue.config.productionTip = false
Vue.prototype.apiBaseUrl = "http://web.p30.net.cn:8082/api/services/app/" ;
Vue.prototype.imageBaseUrl = "http://cdn.p30.net.cn" ;

Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

const messages = {
  //英文
  en: en,
  //简体中文
  cn: cn,
  //日文
  jp: jp
}
const i18n = new VueI18n({
  //定义默认语言
  locale: 'jp',
  messages
});
// router.beforeEach((to, from, next) => {    
//   // chrome
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js